import * as React from 'react';
import { overrideCSS } from '../../utils';
import { IExplorerProperties } from "../../models";

const styles = require('./ResetSearch.pcss');
const internalStyles = require('./ResetSearch.pcss');

interface IProps {
    styles?: Object;
    isFundPage?: boolean;
    isMiniFinder?: boolean;
    isCompare?: boolean;
    compareFn?: Function;
}

export class ResetSearch extends React.Component<IExplorerProperties & IProps, any>{
    constructor(props) {
        super(props);

        this.doSearch = this.doSearch.bind(this);
    }

    doSearch(event, inputValue, isReset: boolean = false) {
        let { appParams } = this.props;
        let url = `${ appParams.baseurl }${ appParams.fundExplorerUrl }/${ process.env.NODE_ENV === "local" ? `${ appParams.productrange }/${ appParams.region }/${ appParams.clienttype }/${ appParams.language }` : "" }?`;
        window.location.href = url;
    }

    render() {
        let styles = this.props.styles ? overrideCSS(internalStyles, this.props.styles) : internalStyles;
        const { isFundPage, isMiniFinder } = this.props;

        return (
            <div className={ styles.resetSearch }>
                { (() => {
                    if (!isFundPage && !isMiniFinder) {
                        return (
                            <div className={ styles.searchInfo }>
                                <a onClick={ event => this.doSearch(event, "", true) }>VIEW ALL FUNDS</a>
                            </div>
                        );
                    }
                })() }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/ResetSearch/ResetSearch.tsx